import COLORS from '../../../themes/Colors'
import TYPOGRAPHY from "../../../themes/Typography"
import { px2Rem } from "../../../themes/Mixins"
import { ZIndex } from '../../../themes/Metrics'

import { FlexBox } from "../../common/Box"
import Description from '../../common/Description'

export const Wrapper = FlexBox.extend`
  position: relative;

  @media (min-width: 768px) {
    flex-direction: column;
  }
`

export const WrapperContext = FlexBox.extend`
  flex-direction: column;
  margin: 0 0 ${px2Rem(40)} ${px2Rem(15)};

  @media (min-width: 768px) {
    position: absolute;
    top: 0;
    flex-direction: row;
    width: 100%;
    margin: 0 0 ${px2Rem(40)};
    z-index: ${ZIndex.tiny};
  }
`

export const WrapperDescription = FlexBox.extend`
  align-items:center;
  justify-content:flex-end;

  @media (min-width: 768px) {
    width: 50%;
    height: ${px2Rem(150)};
  }
`

export const DescriptionItem = Description.extend`
  font-family: ${TYPOGRAPHY.TYPE.base};
  font-size: ${TYPOGRAPHY.SIZE.xxTiny};
  line-height: 1.5;
  margin: 0;

  @media (min-width: 768px) {
    font-family: ${TYPOGRAPHY.TYPE.light};
    font-size: ${TYPOGRAPHY.SIZE.tiny};
    transform: translateX(-120px);
    color: ${COLORS.lighterGray};
    width: ${px2Rem(261)};
    line-height: 1.39;
    text-align: left;
  }

  @media (min-width: 1061px) {
    width: ${px2Rem(384)};
  }
`

export const WrapperImage = FlexBox.extend`
  justify-content: center;
  align-items: flex-start;
  margin: ${px2Rem(5)} 0 0;
  overflow: hidden;

  @media (min-width: 768px) {
    width: ${px2Rem(435)};
    height: ${px2Rem(310)};
    margin: 0;
    align-items: center;
    position: absolute;
    top:  ${props => props.iconName === 'ideate' ? `${px2Rem(-100)}` : `${px2Rem(180)}`};
    right: ${px2Rem(-30)};
    transform: ${props => props.iconName === 'ideate' ? 'rotate(-10deg)' : 'rotate(9deg)'};
  }
`




// WEBPACK FOOTER //
// ./src/components/sections/process/ProcessItemResponsive.js